import { Commands } from "../../../core/src/commands/CommandEnum";
import SoundVars from "../../../core/src/const/SoundVars";
import BetModel from "../../../core/src/model/BetModel";
import AbstractPopup from "../../../core/src/ui/popups/AbstractPopup";
import { UIUpdateEvent } from "../../../core/src/ui/UIUpdateEvents";
import ViewManager from "../../../core/src/utils/ViewManager";
import { AbstractMoneyField } from "../../../core/src/views/AbstractMoneyField";
import Button from "../../../core/src/views/components/Button";
import SceneViewContainer from "../../../core/src/views/SceneViewContainer";
import { Container } from "pixi.js";
import Configs from "../../vendorConfigs/Configs";
import SwitchButton from "../../../core/src/views/components/SwitchButton";
import { MoneyField } from "../../../core/src/views/MoneyField";
import { DefaultLayers } from "../../../core/src/utils/Layers";
import ReelGroup from "../../../core/src/views/ReelGroup";
import PointerEvents from "../../../core/src/const/PointerEvents";
import CommandManager from "../../../core/src/commands/CommandManager";
import SoundController from "../../../core/src/utils/SoundController";
import VendorModel from "../../model/VendorModel";
import { VendorCommandsEnum } from "../../commands/VendorCommandsEnum";
import App from "../../../core/src/App";

export default class BetPopup extends AbstractPopup {
    static fontColor;
    public sceneName: string = "bet";
    protected playBtn: Button;
    protected clearBtn: Button;
    protected options:AbstractMoneyField[];
    protected sliderContainer: SceneViewContainer;
    protected sliderContent: Container;
    protected betArguments: any;
    protected swipReelsWasAllowed: boolean;

    constructor() {
        super();
        this.create();
        this.layer = ViewManager.getLayer("BetBarPopups");
    }

    public show() {
        super.show();

        // if we have special color for over, down..., on buttons text
        if (App.config.betBtnLblStatesColor) {
            BetPopup.fontColor = App.config.betBtnLblStatesColor;
        }
        CommandManager.execute(VendorCommandsEnum.GAME_PAUSED, true); 
        this.betArguments = null;
        this.swipReelsWasAllowed = VendorModel.allowSwipeSpin;
        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
                .getCurrentScene()
                .getSubView("ReelGroup") as ReelGroup;

        if(this.swipReelsWasAllowed) {
            reelGroup.disableSwipeSpin();
        }

        this.scene = this.layer.setScene(this.sceneName);

        this.playBtn = this.scene.buttons.get("play");
        this.playBtn.on(PointerEvents.DOWN, () => {
            if(this.betArguments) {
                CommandManager.execute(Commands.SET_BET, this.betArguments);
            }
            CommandManager.execute(Commands.SAVE_SETTINGS);
            CommandManager.execute(Commands.TOGGLE_BET_POPUP, true);
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        });

        this.clearBtn = this.scene.buttons.get("clear");
        this.assignInterraction(
            Commands.TOGGLE_BET_POPUP, 
            this.clearBtn,
            SoundVars.BUTTON_CLICK,
            true
        );
        
        let j = 0;
        let validBetsOptions = Configs.bet.getBetOptions();
        while (this.scene.buttons.has("betAmount~" + (j + 1))) {
            let value = validBetsOptions[j];
            this.setBet(value, j);
            j++
        }

        this.update(UIUpdateEvent.Bet);
        this.scene.orientationChangeCallback = ()=> {
            let j = 0;
            let validBetsOptions = Configs.bet.getBetOptions();
            while (this.scene.buttons.has("betAmount~" + (j + 1))) {
                let value = validBetsOptions[j];
                this.setBet(value, j);
                j++
            }
        }
        this.scene.onOrientationChange();
    }

    protected setBet = (value: number, j: number): void => {
        let btn = this.scene.buttons.get(
            "betAmount~" + (j + 1)
        ) as SwitchButton;
        btn.switch(BetModel.coinSizeIndex == j);
        let betField = this.scene.sceneMoneyFields.get(
            "betAmount~" + (j + 1)
        ) as MoneyField;
        if (!value) {
            btn.visible = false;
            betField.visible = false;
        } else {
            betField.value = value as number;
            if (BetPopup.fontColor && btn.isSelected()) {
                betField.changeColor(BetPopup.fontColor.down);
            }
            btn.on(PointerEvents.DOWN, () => {
                this.betArguments = this.getBetOptionsBtnInteractionParams(value);
                SoundController.playSound(SoundVars.BUTTON_CLICK);
                CommandManager.execute(VendorCommandsEnum.CHANGED_BET, this.betArguments);

                if (BetPopup.fontColor) {
                    this.scene.sceneMoneyFields.forEach((field) => {
                        if (field instanceof MoneyField) {
                            field.changeColor(BetPopup.fontColor.out);
                        }
                    })
                    betField.changeColor(BetPopup.fontColor.down);
                } 
            });
            btn.on(PointerEvents.OVER, () => {
                if (BetPopup.fontColor && !btn.isSelected()) {
                    betField.changeColor(BetPopup.fontColor.over);
                }
            });
            btn.on(PointerEvents.ROLLOUT, () => {
                if (BetPopup.fontColor && !btn.isSelected()) {
                    betField.changeColor(BetPopup.fontColor.out);
                }
            });
            
            betField.applyLabelSettings({ scaleX: 0.92, scaleY: 0.92, offsetX: 0, offsetY: 0});
        }
    }

    protected getBetOptionsBtnInteractionParams(value: number) {
        return BetModel.getPossibleBetByIndex(BetModel.creditValues.indexOf(value))
    }

    public update(event) {
        if (this.scene && event == UIUpdateEvent.Bet) {
            // this.scene.sceneTextFields.get('coinAmount').text = BetModel.formatCurrency(BetModel.coinSize);
            // this.scene.sceneTextFields.get('betAmount').text = BetModel.currentBetMultiplier + '/' + BetModel.betMultiplierMax;
        }

    }

    public hide() {
        if(this.swipReelsWasAllowed) {
            let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
                .getCurrentScene()
                .getSubView("ReelGroup") as ReelGroup;
            reelGroup.enableSwipeSpin();
        }
        
        this.playBtn.off(PointerEvents.DOWN);
        this.playBtn.off(PointerEvents.OVER);
        this.playBtn.off(PointerEvents.ROLLOUT);
        CommandManager.execute(VendorCommandsEnum.GAME_PAUSED, false);
        super.hide();
    }
}